import { visibleNavItems } from "../data/navigation";

function AppMenu({ auth, compact = false, page, setPage }) {
  const items = visibleNavItems(auth);

  return (
    <nav className={`app-menu ${compact ? "compact" : ""}`} aria-label="App menu">
      {items.map((item) => (
        <button
          className={page === item.id ? "active" : ""}
          key={item.id}
          onClick={() => setPage(item.id)}
          type="button"
        >
          <span>{item.icon}</span>
          {item.label}
        </button>
      ))}
    </nav>
  );
}

export default AppMenu;
